<template>
  <driver-detail :is-edit="false" />
</template>

<script>
    import DriverDetail from './components/DriverDetail';
    export default {
        name: "CreateVehicle",
        components: { DriverDetail }
    }
</script>

<style scoped>

</style>
